import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DK&area=female&exp=web_pricing_au_dk_se_ch~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_au_dk_se_ch/f'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DK&area=female-water-fasting&exp=web_pricing_au_dk_se_ch~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_au_dk_se_ch/f'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DK&area=activity-female-tai-chi-walking-v2&exp=web_pricing_au_dk_se_ch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_au_dk_se_ch/tai-chi-walking-f-v2'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DK&area=activity-female-walking&exp=web_pricing_au_dk_se_ch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_au_dk_se_ch/tai-chi-walking-f-v2'
					),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DK&area=activity-male-chair-tai-chi&exp=web_pricing_au_dk_se_ch~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_au_dk_se_ch/chair-tai-chi-m'
					),
			},
		},
	},
]

export default config
